export const FLOOR_17_DATA = [
  {
    floor: 17,
    building: 'A',
    apartmentNumber: 'talokerho2',
    sceneName: 'scene_17krs_talokerho2',
    sceneName_future: 'scene_17krs_talokerho2_future',
    name: 'talokerho2',
    label: 'Kerhotila',
    lookAt: '161.30, 0, 120',
    face: 'south',

    relatedApartments: {
      2: 'A009',
      3: 'A018',
      4: 'A027',
      5: 'A036',
      6: 'A045',
      7: 'A054',
      8: 'A063',
      9: 'A072',
      10: 'A081',
      11: 'A090',
      12: 'A099',
      13: 'A108',
      14: 'A117',
      15: 'A125',
      16: 'A133',
    },
  },
  {
    floor: 17,
    building: 'A',
    apartmentNumber: 'talosauna2',
    sceneName: 'scene_17krs_talosauna2',
    sceneName_future: 'scene_17krs_talosauna2_future',
    name: 'talosauna2',
    label: 'Sauna 2',
    lookAt: '161.30, 0, 120',
    face: 'south',

    relatedApartments: {
      2: 'A007',
      3: 'A016',
      4: 'A025',
      5: 'A034',
      6: 'A043',
      7: 'A052',
      8: 'A061',
      9: 'A070',
      10: 'A079',
      11: 'A088',
      12: 'A097',
      13: 'A106',
      14: 'A115',
      15: 'A123-1',
      16: 'A131-1',
    },
  },
  {
    floor: 17,
    building: 'A',
    apartmentNumber: 'talosauna3',
    sceneName: 'scene_17krs_talosauna3',
    sceneName_future: 'scene_17krs_talosauna3_future',
    name: 'talosauna3',
    label: 'Sauna 3',
    lookAt: '161.30, 0, 120',
    face: 'south',

    relatedApartments: {
      2: 'A008',
      3: 'A017',
      4: 'A026',
      5: 'A035',
      6: 'A044',
      7: 'A053',
      8: 'A062',
      9: 'A071',
      10: 'A080',
      11: 'A089',
      12: 'A098',
      13: 'A107',
      14: 'A116',
      15: 'A124',
      16: 'A132',
    },
  },
]
